import './App.css';
import {
    Card,
    Col,
    Flex,
    Row,
} from 'antd';
import useSWR from 'swr';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import { ClockCircleOutlined } from '@ant-design/icons';
import Loading from './Loading';

const { Title } = Typography;

interface cutType {
    id: number;
    title: string;
    bvid: string;
    time: string;
    link: string;
    cover: string;
    type: string;
}

const fetcher = async (url: string) => {
    const res = await fetch(url, {
        headers: new Headers({
            'Access-Control-Allow-Origin': '*',
        }),
    });
    const json = await res.json();
    if (!json.success) {
        const error = new Error((await json).message);
        throw error;
    }
    return json;
};

const Video = () => {
    const {
        data: cutData,
        error: cutError,
        isLoading: cutIsLoading,
    } = useSWR('https://api.lynne.com.cn/video/newCut', fetcher);
    const {
        data: recordData,
        error: recordError,
        isLoading: recordIsLoading,
    } = useSWR('https://api.lynne.com.cn/video/newRecord', fetcher);
    if (cutIsLoading || recordIsLoading) return <Loading />;
    if (cutError || recordError) return <div>failed to load</div>;

    // 渲染数据
    return (
        <>
            <Flex align='center' justify='middle'>
                <Title level={2} style={{ margin: '15px 0' }}>
                    直播回放&切片~
                </Title>
            </Flex>
            <Row gutter={[10, 10]}>
                <Col xs={24} sm={24} md={12}>
                    <Card
                        title='直播回放'
                        extra={<a href='/video/replay'>查看更多</a>}
                        style={{ width: '100%' }}>
                        {recordData.data.map((cut: cutType) => {
                            return (
                                <Card
                                    key={cut.id}
                                    hoverable
                                    onClick={() => window.open(cut.link, 'bilibili', 'noopener=yes,noreferrer=yes')}
                                    style={{margin: '10px 0'}}>
                                    <Row
                                        gutter={5}
                                        align={'middle'}
                                        justify={'center'}>
                                        <Col xs={24} sm={8} md={8}>
                                            <img
                                                src={cut.cover}
                                                className='videoImg'
                                                alt={cut.title}
                                            />
                                        </Col>
                                        <Col xs={24} sm={16} md={16}>
                                            <Title
                                                level={4}
                                                style={{ margin: '15px 0' }}>
                                                {cut.title}
                                            </Title>
                                            <Row
                                                gutter={5}
                                                align={'middle'}
                                                style={{ marginLeft: '5px' }}>
                                                <Col>
                                                    <ClockCircleOutlined />
                                                </Col>
                                                <Col>
                                                    {dayjs(cut.time).format(
                                                        'YYYY-MM-DD HH:mm:ss'
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            );
                        })}
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <Card
                        title='直播切片'
                        extra={<a href='/video/cut'>查看更多</a>}
                        style={{ width: '100%' }}>
                        {cutData.data.map((cut: cutType) => {
                            return (
                                <Card
                                    key={cut.id}
                                    hoverable
                                    onClick={() => window.open(cut.link, 'bilibili', 'noopener=yes,noreferrer=yes')}
                                    style={{margin: '10px 0'}}>
                                    <Row
                                        gutter={5}
                                        align={'middle'}
                                        justify={'center'}>
                                        <Col xs={24} sm={8} md={8}>
                                            <img
                                                src={cut.cover}
                                                className='videoImg'
                                                alt={cut.title}
                                            />
                                        </Col>
                                        <Col xs={24} sm={16} md={16}>
                                            <Title
                                                level={4}
                                                style={{ margin: '15px 0' }}>
                                                {cut.title}
                                            </Title>
                                            <Row
                                                gutter={5}
                                                align={'middle'}
                                                style={{ marginLeft: '5px' }}>
                                                <Col>
                                                    <ClockCircleOutlined />
                                                </Col>
                                                <Col>
                                                    {dayjs(cut.time).format(
                                                        'YYYY-MM-DD HH:mm:ss'
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            );
                        })}
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default Video;
